// Custom day cell content rendering helper
export const renderDayCellContent = (arg, dayData) => {
  if (!dayData) return;

  const isUpcoming = dayData.status === "upcoming";
  const isRest = dayData.status === "rest";

  // Create container for custom content
  const container = document.createElement("div");
  container.style.padding = "4px 8px";
  container.style.fontSize = "12px";
  container.style.marginTop = "8px";
  container.style.display = "flex";
  container.style.flexDirection = "column";
  container.style.gap = "4px";
  container.style.pointerEvents = "none"; // Allow clicks to pass through

  if (isRest) {
    container.innerHTML = `
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
      ">
        <span style="
          color: #1976d2;
          font-size: 11px;
          font-weight: 500;
        ">No deliveries</span>
      </div>
    `;
  } else if (isUpcoming) {
    container.innerHTML = `
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        color: #9e9e9e;
        font-size: 11px;
      ">-</div>
    `;
  } else if (dayData.status === "completed") {
    let shiftsHTML = "";

    // Info icon with tooltip
    const infoIconHTML = `
      <div style="position: absolute; top: 8px; left: 8px; pointer-events: auto;" class="info-icon-wrapper">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#757575" style="cursor: pointer; transition: fill 0.2s;" class="info-icon">
          <path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"/>
        </svg>
        <div class="custom-tooltip" style="
          position: absolute;
          top: 24px;
          left: 0;
          background: rgba(33, 33, 33, 0.95);
          color: white;
          padding: 12px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          min-width: 180px;
          z-index: 1000;
          display: none;
          white-space: nowrap;
        ">
          <div style="display: flex; flex-direction: column; gap: 8px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#4caf50">
                <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
              </svg>
              <span style="font-size: 14px;"><strong>${
                dayData.deliveredOrders
              }</strong> Order${
      dayData.deliveredOrders !== 1 ? "s" : ""
    } Delivered</span>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#ff9800">
                <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m4.2 14.2L11 13V7h1.5v5.2l4.5 2.7l-.8 1.3Z"/>
              </svg>
              <span style="font-size: 14px;"><strong>${
                dayData.hoursWorked
              }</strong> Hour${
      dayData.hoursWorked !== 1 ? "s" : ""
    } Worked</span>
            </div>
          </div>
        </div>
      </div>
    `;

    if (dayData.shift === "AM") {
      shiftsHTML = `
        <div style="display: flex; align-items: center; gap: 4px;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#ef6c00">
            <path d="M18 18.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m1.5-9l1.96 2.5L17 13V9.5m-11 9A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5l-3-4Z"/>
          </svg>
          <span style="color: #ef6c00; font-weight: bold; font-size: 12px;">${dayData.amOrders} AM</span>
        </div>
      `;
    } else if (dayData.shift === "PM") {
      shiftsHTML = `
        <div style="display: flex; align-items: center; gap: 4px;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#7b1fa2">
            <path d="M18 18.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m1.5-9l1.96 2.5L17 13V9.5m-11 9A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5l-3-4Z"/>
          </svg>
          <span style="color: #7b1fa2; font-weight: bold; font-size: 12px;">${dayData.pmOrders} PM</span>
        </div>
      `;
    } else if (dayData.shift === "AM/PM") {
      shiftsHTML = `
        <div style="display: flex; flex-direction: column; gap: 2px;">
          <div style="display: flex; align-items: center; gap: 4px;">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#ef6c00">
              <path d="M18 18.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m1.5-9l1.96 2.5L17 13V9.5m-11 9A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5l-3-4Z"/>
            </svg>
            <span style="color: #ef6c00; font-weight: bold; font-size: 11px;">${dayData.amOrders} AM</span>
          </div>
          <div style="display: flex; align-items: center; gap: 4px;">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#7b1fa2">
              <path d="M18 18.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m1.5-9l1.96 2.5L17 13V9.5m-11 9A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5l-3-4Z"/>
            </svg>
            <span style="color: #7b1fa2; font-weight: bold; font-size: 12px;">${dayData.pmOrders} PM</span>
          </div>
        </div>
      `;
    }

    // Hours worked
    const hoursHTML = `
      <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#9e9e9e">
          <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m4.2 14.2L11 13V7h1.5v5.2l4.5 2.7l-.8 1.3Z"/>
        </svg>
        <span style="color: #757575; font-size: 11px;">${dayData.hoursWorked}h</span>
      </div>
    `;

    container.innerHTML = infoIconHTML + shiftsHTML + hoursHTML;

    // Add hover event listeners after inserting HTML
    const dayFrame = arg.el.querySelector(".fc-daygrid-day-frame");
    if (dayFrame) {
      dayFrame.appendChild(container);

      // Get the info icon wrapper and tooltip
      const infoWrapper = dayFrame.querySelector(".info-icon-wrapper");
      const tooltip = dayFrame.querySelector(".custom-tooltip");
      const icon = dayFrame.querySelector(".info-icon");

      if (infoWrapper && tooltip && icon) {
        infoWrapper.addEventListener("mouseenter", () => {
          tooltip.style.display = "block";
          icon.style.fill = "#1976d2";
        });

        infoWrapper.addEventListener("mouseleave", () => {
          tooltip.style.display = "none";
          icon.style.fill = "#757575";
        });
      }
    }
    return; // Early return since we've already appended the container
  }

  // Append to the day cell (only for rest and upcoming days, completed days already handled)
  const dayFrame = arg.el.querySelector(".fc-daygrid-day-frame");
  if (dayFrame && (isRest || isUpcoming)) {
    dayFrame.appendChild(container);
  }
};

// Day cell class names helper
export const getDayCellClassNames = (dayData) => {
  if (!dayData) return "";

  let classes = [];

  if (dayData.status === "upcoming") classes.push("fc-upcoming-day");
  if (dayData.status === "rest") classes.push("fc-rest-day");
  if (dayData.status === "completed") classes.push("fc-completed-day");

  return classes.join(" ");
};

// Calendar styles
export const calendarStyles = {
  "& .fc": {
    fontFamily: "inherit",
  },
  "& .fc-theme-standard td, & .fc-theme-standard th": {
    borderColor: "#e0e0e0",
  },
  "& .fc-daygrid-day": {
    transition: "all 0.2s ease",
  },
  "& .fc-daygrid-day-frame": {
    minHeight: "120px",
    padding: "4px",
  },
  "& .fc-col-header-cell": {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    padding: "12px",
    fontSize: "14px",
  },
  "& .fc-day-today .fc-daygrid-day-frame": {
    border: "2px solid #1976d2",
    borderRadius: "4px",
    backgroundColor: "#e3f2fd !important",
  },
  "& .fc-upcoming-day": {
    backgroundColor: "#fafafa",
    "& .fc-daygrid-day-frame": {
      cursor: "not-allowed",
    },
  },
  "& .fc-rest-day": {
    backgroundColor: "#e3f2fd",
    "& .fc-daygrid-day-frame": {
      cursor: "not-allowed",
    },
  },
  "& .fc-completed-day": {
    backgroundColor: "white",
    "& .fc-daygrid-day-frame": {
      cursor: "pointer",
      "&:hover": {
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        borderColor: "#1976d2",
      },
    },
  },
  "& .fc-button": {
    backgroundColor: "#1976d2",
    border: "none",
    textTransform: "none",
    fontWeight: "600",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
    "&:focus": {
      boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.3)",
    },
  },
  "& .fc-button-primary:not(:disabled).fc-button-active": {
    backgroundColor: "#1565c0",
  },
  "& .fc-toolbar-title": {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#212121",
  },
  "& .fc-daygrid-day-number": {
    padding: "4px",
  },
};
